import { APICore } from "./apiCore";
const api = new APICore();

const getServiceOption = (params) => {
    const baseUrl = '/sql_type/service_option'
    return api.get(`${baseUrl}`, params);
};

const getRoleOption = (params) => {
    const baseUrl = `/sql_type/roleType`;
    return api.get(`${baseUrl}`, params);
};

export { getServiceOption, getRoleOption }